import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useErrorContext } from './../../components/messages/ErrorBox';
import { usePageLoadingContext } from './../../components/messages/PageLoading';
import { useLocale } from './../../components/special/LanguageProvider';
import { apiGetCall, apiPostCall, isResultOk } from './../../components/special/apiCall';
import  EditForm  from 'components/form/EditForm';
import  EditFormFieldTable  from 'components/form/EditFormFieldTable';
import InputDate from './../../components/input/InputDate';
import InputNumber from './../../components/input/InputNumber';
import Warning from 'jsx/elements/messages/Warning';

const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

export const TableRateEdit = ({history}) => {
  
  const params = new URLSearchParams(useLocation().search);  
  const setCheckErrorItems = useErrorContext();
  const setIsPageLoading = usePageLoadingContext();
  const { t } = useLocale();

  const [isNew, setIsNew] = useState(true);
  const [messageBox, setMessageBox] = useState({ showMessageBox : false,
                                                  messageBoxText : "",
                                                  messageBoxType : "" })

  //Init blank data record
  const [data, setData] = useState({
    tableTypeID : 0,
    tableID : 0,     
    tableTypeName : "",
    tableName : "",
    pointDate : null,
    value : 0.0,
    extraValue : 0.0
  });


  const goBack = (tableTypeID, tableID) => {
    if (tableTypeID != null && tableID == null){
        history.push("/admin/tables?tabletypeid="+tableTypeID);
    }
    else if (tableTypeID != null && tableID != null){
      history.push("/admin/tablerates?tabletypeid="+tableTypeID+"&tableid=" + tableID);
    }
    else{
      history.push("/admin/tabletypes");
    }
  }

  const loadFormData = async() => {
    setIsPageLoading(true);
    let isNew = params.get("new");
    let newData = {...data, tableTypeID : params.get("tabletypeid"), tableID : params.get("tableid"), pointDate :  params.get("pointdate")};
    if (!isNew && newData.tableID > 0){
      setIsNew(false);
      const rateTableRes = await apiPostCall(BASE_URL + '/admin/table/rate', newData);
      if (isResultOk(rateTableRes, setCheckErrorItems)){
        newData.tableName = rateTableRes.tableName;
        newData.tableTypeName = rateTableRes.tableTypeName;
        newData.pointDate = rateTableRes.pointDate;
        newData.extraValue = rateTableRes.extraValue;
        newData.value = rateTableRes.value;
      }
    }
    else{
      const rateTableRes = await apiGetCall(BASE_URL + '/admin/table/rate/summary/' + newData.tableTypeID + "/" + newData.tableID);
      if (isResultOk(rateTableRes, setCheckErrorItems)){
        newData.tableName = rateTableRes.tableName;
        newData.tableTypeName = rateTableRes.tableTypeName;
      }
    }
    setData(newData);
    setIsPageLoading(false);
  }

  useEffect(() => {
    loadFormData();
  }, []);

  const onSaveClick = async() => {
    setIsPageLoading(true);
    let requestResult = null;
    if (isNew){
      requestResult = await apiPostCall(BASE_URL + '/admin/table/rate/create', data);
    }
    else{
      requestResult = await apiPostCall(BASE_URL + '/admin/table/rate/change', data);
    }
    if (requestResult != null && requestResult.error.message == "There can only exist one rate per day"){
      triggerMessageBox("Það er til punktur með þessari dagsetningu", "alert");
    }
    else if (isResultOk(requestResult, setCheckErrorItems)){
      goBack(data.tableTypeID, data.tableID);
    }
    setIsPageLoading(false);
  }

  const onBackClick = () => {
    goBack(data.tableTypeID, data.tableID);
  }

  function triggerMessageBox(text, type) {
    setMessageBox({ showMessageBox : true,
      messageBoxText : text,
      messageBoxType : type });
  }

  const validateInput = async () => {
    let messages = [];
    if (data.pointDate == null){
      messages.push("Vantar að velja dagsetningu (gildir frá)");
    }
    if (data.value == null || data.value === 0){
      messages.push("Vantar gildi");
    }
    setMessageBox({ ...messageBox, showMessageBox : false })
    return messages; 
  }

  let fields = [
    {
      title: "Gildir frá",
      edit : <InputDate value={data.pointDate} onChange={(value) => setData({...data, pointDate : value})} disabled={!isNew} />
    },
    {
      title: "Gildi",
      edit : () => <InputNumber value={data.value} onChange={(value) => setData({...data, value : value})} allowNegative={true} decimalScale={5}/>           
    }
  ];

  if (data.extraValue) {
    fields.push(
      {
        title: "Gildi 2",
        edit : () => <InputNumber value={data.extraValue} onChange={(value) => setData({...data, extraValue : value})} allowNegative={true} decimalScale={5}/>           
      }
    );
  }

  return (
    <div>
      <a href={"/admin/tabletypes"}>{t("Forsendutöflur")}</a> - <a href={"/admin/tables?tabletypeid="+ data.tableTypeID}>{data.tableTypeName}</a> - <a href={"/admin/tablerates?tabletypeid="+data.tableTypeID+"&tableid=" + data.tableID}>{data.tableName}</a>
      <EditForm title={isNew ? "Nýr punktur" : "Uppfæra punkt"} onSubmitClick={onSaveClick} onBackClick={onBackClick} onValidate={validateInput}>
        {messageBox.showMessageBox && <Warning messageHeader={messageBox.messageBoxText} messageType={messageBox.messageBoxType}/>}
        <EditFormFieldTable fields={fields}/>            
      </EditForm>  
    </div>  
  );
}





